import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
    Table
    , Pagination
    , Loader
    , Button
    , IconButton
    , ButtonToolbar
    , Input
    , Tooltip
    , Whisper
    , Modal
    , VStack
    , SelectPicker
    , InputGroup
    , AutoComplete
} from 'rsuite';

import Swal from 'sweetalert2'
import $ from 'jquery';

export default class SchoolsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            content: null,
            modal: null,
            loading: false,
            data: [],
            sortColumn: '',
            sortType: '',
            loading: false,
            limit: 15,
            page: 1,
            school_name: '',
            school_type: ''
        };
    }

    async componentDidMount() {
        this.onRenderContent({ mode: 'read', query: '' })
    }

    onRenderContent = async ({ mode, query }) => {
        if (mode === 'read') {
            const { Column, HeaderCell, Cell } = Table;

            try {
                await this.promisedSetState({ loading: true }); // Set loading state

                const responseAPI = await axios.post(`${process.env.REACT_APP_API}/schools/filter`, { query: query }, this.state.authHeader);
                const data = responseAPI.data.map((res, index) => ({
                    index: index + 1,
                    id: res.id,
                    name: res.name,
                    type: res.type
                }));

                await this.promisedSetState({ data: data });

                const paginatedData = await this.getData();

                const autoComplete = responseAPI.data.map((res) => [
                    res.name
                ]);

                const flatAutoComplete = autoComplete.flat();

                const uniqueFlatAutoComplete = [...new Set(flatAutoComplete)];

                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg'>
                                    <Breadcrumb.Item>
                                        <Link to="/admin"><i className="bi bi-house-fill"></i></Link>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>รายชื่อสถานศึกษา</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Button size='sm'
                                    startIcon={<i className="bi bi-plus-lg"></i>}
                                    color="green"
                                    appearance="primary"
                                    onClick={() => this.onModal({ mode: 'insert' })} >
                                    เพิ่ม
                                </Button>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Button tabIndex={-1}>
                                        <i className="bi bi-search"></i>
                                    </InputGroup.Button>
                                    <AutoComplete 
                                    data={uniqueFlatAutoComplete}
                                    onChange={e => this.onRenderContent({ mode: 'read', query: e })} />
                                </InputGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Table
                                    autoHeight
                                    data={paginatedData}
                                    bordered
                                    cellBordered
                                    sortColumn={this.state.sortColumn}
                                    sortType={this.state.sortType}
                                    onSortColumn={async (sortColumn, sortType) => {
                                        await this.handleSortColumn(sortColumn, sortType);
                                    }}
                                    className='shadow-sm'
                                >
                                    <Column width={60} align="center">
                                        <HeaderCell>ลำดับ</HeaderCell>
                                        <Cell dataKey="index" />
                                    </Column>

                                    <Column width={605} sortable>
                                        <HeaderCell>ชื่อสถานศึกษา</HeaderCell>
                                        <Cell dataKey="name" />
                                    </Column>

                                    <Column width={530} sortable>
                                        <HeaderCell>ประเภท</HeaderCell>
                                        <Cell dataKey="type" />
                                    </Column>

                                    <Column width={100} align='center' fixed="right">
                                        <HeaderCell>...</HeaderCell>
                                        <Cell style={{ padding: '6px' }}>
                                            {rowData => (
                                                <ButtonToolbar>
                                                    <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                            <IconButton size='sm'
                                                                color="yellow"
                                                                appearance="primary"
                                                                icon={<i className="bi bi-pencil-square"></i>}
                                                                onClick={() => this.onModal({ mode: 'update', id: rowData.id })}
                                                            />
                                                    </Whisper>
                                                    <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="red"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-trash-fill"></i>}
                                                            onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                        />
                                                    </Whisper>
                                                </ButtonToolbar>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>

                                <div style={{ padding: 20 }}>
                                    <Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '|', 'pager']}
                                        total={data.length}
                                        limit={this.state.limit}
                                        activePage={this.state.page}
                                        onChangePage={async (e) => {
                                            await this.promisedSetState({ page: e }); // Update current page
                                            await this.onRenderContent({ mode: 'read', query: '' }); // Fetch new data based on page
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </>
                });
            } catch (error) {
                console.error('API request failed:', error);
                // Consider adding user feedback here
                
                // Redirect to Log In
                window.location.href = '/admin/login';
            } finally {
                await this.promisedSetState({ loading: false }); // Reset loading state
            }
        }
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    handleSortColumn = async (sortColumn, sortType) => {
        await this.promisedSetState({ loading: true });

        await new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });

        await this.promisedSetState({ loading: false });
        await this.promisedSetState({ sortColumn, sortType });

        // Call your onRenderContent function if needed
        await this.onRenderContent({ read: true, query: '' });
    };

    getData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    onModal = async ({ mode, id }) => {
        if (mode === 'insert') {
            await this.promisedSetState({
                school_name: '',
                school_type: ''
            })

            await this.promisedSetState({ modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>เพิ่มรายชื่อสถานศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>ชื่อสถานศึกษา</label>
                                        <Input 
                                        className='fJESa'
                                        size='sm'
                                        onChange={e => this.setState({ school_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <VStack>
                                        <label>ประเภท</label>
                                        <SelectPicker
                                            className='HEJ0H'
                                            size='lg'
                                            data={[{ label: 'มหาวิทยาลัยของรัฐ', value: 'มหาวิทยาลัยของรัฐ' },
                                            { label: 'มหาวิทยาลัยในกำกับรัฐ', value: 'มหาวิทยาลัยในกำกับรัฐ' },
                                            { label: 'มหาวิทยาลัยเอกชน', value: 'มหาวิทยาลัยเอกชน' },
                                            { label: 'มหาวิทยาลัยราชภัฎ', value: 'มหาวิทยาลัยราชภัฎ' },
                                            { label: 'มหาวิทยาลัยเทคโนโลยีราชมงคล', value: 'มหาวิทยาลัยเทคโนโลยีราชมงคล' },
                                            { label: 'มหาวิทยาลัยรัฐไม่จำกัดรับ', value: 'มหาวิทยาลัยรัฐไม่จำกัดรับ' },
                                            { label: 'สถาบันเอกชน', value: 'สถาบันเอกชน' },
                                            { label: 'วิทยาลัยเอกชน', value: 'วิทยาลัยเอกชน' },
                                            ]}
                                            searchable={false}
                                            placeholder="กรุณาเลือก"
                                            style={{ width: '100%' }}
                                            onChange={e => this.setState({ school_type: e })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'insert' })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        } else if (mode === 'update') {

            const { data } = await axios.get(`${process.env.REACT_APP_API}/schools/${id}`, this.state.authHeader);
            const school = data[0];  // Assuming `data` is an array

            await this.promisedSetState({
                school_name: school.name,
                school_type: school.type
            })

            await this.promisedSetState({ modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>เพิ่มรายชื่อสถานศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>ชื่อสถานศึกษา</label>
                                        <Input 
                                        className='fJESa'
                                        size='sm'
                                        defaultValue={school.name}
                                        onChange={e => this.setState({ school_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <VStack>
                                        <label>ประเภท</label>
                                        <SelectPicker
                                            className='HEJ0H'
                                            size='lg'
                                            data={[{ label: 'มหาวิทยาลัยของรัฐ', value: 'มหาวิทยาลัยของรัฐ' },
                                            { label: 'มหาวิทยาลัยในกำกับรัฐ', value: 'มหาวิทยาลัยในกำกับรัฐ' },
                                            { label: 'มหาวิทยาลัยเอกชน', value: 'มหาวิทยาลัยเอกชน' },
                                            { label: 'มหาวิทยาลัยราชภัฎ', value: 'มหาวิทยาลัยราชภัฎ' },
                                            { label: 'มหาวิทยาลัยเทคโนโลยีราชมงคล', value: 'มหาวิทยาลัยเทคโนโลยีราชมงคล' },
                                            { label: 'มหาวิทยาลัยรัฐไม่จำกัดรับ', value: 'มหาวิทยาลัยรัฐไม่จำกัดรับ' },
                                            { label: 'สถาบันเอกชน', value: 'สถาบันเอกชน' },
                                            { label: 'วิทยาลัยเอกชน', value: 'วิทยาลัยเอกชน' },
                                            ]}
                                            searchable={false}
                                            placeholder="กรุณาเลือก"
                                            style={{ width: '100%' }}
                                            defaultValue={school.type}
                                            onChange={e => this.setState({ school_type: e })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'update', id })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        }
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode, id }) => {

        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.school_name, 'fJESa', ''),
                this.Validate(this.state.school_type, 'HEJ0H', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'insert') {
            if (await validate()) {
                const Response = await axios.post(`${process.env.REACT_APP_API}/schools`, {
                    name: this.state.school_name,
                    type: this.state.school_type,
                }, this.state.authHeader);

                const schools = Response.data;

                if (schools.message === 'successfully') {

                    await this.onRenderContent({ mode: 'read', query: '' })

                    await this.promisedSetState({ modal: null })

                    Swal.fire({
                        title: "คุณเพิ่มข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        } else if (mode === 'update') {
            if (await validate()) {
                const Response = await axios.put(`${process.env.REACT_APP_API}/schools`, {
                    id: id,
                    name: this.state.school_name,
                    type: this.state.school_type,
                }, this.state.authHeader);

                const schools = Response.data;

                if (schools.message === 'successfully') {

                    await this.onRenderContent({ mode: 'read', query: '' })

                    await this.promisedSetState({ modal: null })

                    Swal.fire({
                        title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        } else if (mode === 'delete') {
            Swal.fire({
                title: "คุณต้องการลบใช่หรือไม่?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    const Response = await axios.delete(`${process.env.REACT_APP_API}/schools/${id}`, this.state.authHeader);

                    const schools = Response.data;

                    if (schools.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read', query: '' })

                        Swal.fire({
                            title: "คุณลบข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                } else if (result.isDenied) {

                    await this.onRenderContent({ mode: 'read', query: '' })
                }
            });
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
